import FoodDetail from "../components/CardFoods/FoodDetail";
import FooterComp from "../components/FooterComs/FooterComp";
import NavbarComp from "../components/NavbarComs/NavbarComp";

const FoodDetailPage = () => {
  return (
    <>
      <NavbarComp />
      <FoodDetail />
      <FooterComp />
    </>
  );
};

export default FoodDetailPage;
